export const createCandidateBatch = /* GraphQL */ `
  mutation CreateCandidateBatch(
    $input: CreateCandidateBatchInput!
    $condition: ModelCandidateBatchConditionInput
  ) {
    createCandidateBatch(input: $input, condition: $condition) {
      id
      cvS3Keys
      csvS3Key
      jobDescription
      status
      createdAt
      updatedAt
    }
  }
`;

export const updateCandidate = /* GraphQL */ `
  mutation UpdateCandidate(
    $input: UpdateCandidateInput!
    $condition: ModelCandidateConditionInput
  ) {
    updateCandidate(input: $input, condition: $condition) {
      id
      totalScore
      totalScoreScaled
      analysisErrorCode
      firstName
      lastName
      phoneNumber
      email
      candidateBatchId
      conversationId
      createdAt
      updatedAt
      scoring {
        category
        weight
        score
        scoreScaled
        description
      }
      status
      organizationId
      isLocked
    }
  }
`;

export const startCandidateBatchProcessing = /* GraphQL */ `
  mutation StartCandidateBatchProcessing(
    $input: StartCandidateBatchProcessingInput!
  ) {
    startCandidateBatchProcessing(input: $input) {
      message
    }
  }
`;

export const updateCandidateBatch = /* GraphQL */ `
  mutation UpdateCandidateBatch(
    $input: UpdateCandidateBatchInput!
    $condition: ModelCandidateBatchConditionInput
  ) {
    updateCandidateBatch(input: $input, condition: $condition) {
      id
      cvS3Keys
      csvS3Key
      jobDescription
      status
      candidatesCount
      candidatesToProcessCount
      organizationId
      userId
      screeningQuestions {
        content
        supportingInformation
        isMandatory
      }
      jobDescriptionParsed {
        jobTitle
        employerName
        location
        contractType
        hours
        salary
        closingDate
        summaryOfRole
        responsibilities
        qualifications
        benefits
        diversityEqualityInclusion
      }
      createdAt
      updatedAt
      weights {
        relevantExperience
        relevantQualifications
        relevantSkills
        softSkills
      }
    }
  }
`;

export const initializeCandidateBatch = /* GraphQL */ `
  mutation InitializeCandidateBatch($input: InitializeCandidateBatchInput!) {
    initializeCandidateBatch(input: $input) {
      id
      cvS3Keys
      csvS3Key
      jobDescription
      status
      weights {
        relevantExperience
        relevantQualifications
        relevantSkills
        softSkills
      }
      campaignId
      candidatesCount
      candidatesToProcessCount
      organizationId
      userId
      jobDescriptionParsed {
        jobTitle
        employerName
        location
        contractType
        hours
        salary
        closingDate
        summaryOfRole
        responsibilities
        qualifications
        benefits
        diversityEqualityInclusion
      }
      screeningQuestions {
        content
        supportingInformation
        isMandatory
      }
      createdAt
      updatedAt
    }
  }
`;

export const startCandidateMessagesGeneration = /* GraphQL */ `
  mutation StartCandidateMessageGeneration(
    $input: StartCandidateMessageGenerationInput!
  ) {
    startCandidateMessagesGeneration(input: $input) {
      message
    }
  }
`;

export const createCandidateNote = /* GraphQL */ `
  mutation CreateCandidateNote(
    $input: CreateCandidateNoteInput!
    $condition: ModelCandidateNoteConditionInput
  ) {
    createCandidateNote(input: $input, condition: $condition) {
      id
      content
      candidateId
      organizationId
      userId
      user {
        id
        name
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;

export const updateCandidateNote = /* GraphQL */ `
  mutation UpdateCandidateNote(
    $input: UpdateCandidateNoteInput!
    $condition: ModelCandidateNoteConditionInput
  ) {
    updateCandidateNote(input: $input, condition: $condition) {
      id
      content
      candidateId
      organizationId
      userId
      user {
        id
        name
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;

export const deleteCandidateNote = /* GraphQL */ `
  mutation DeleteCandidateNote(
    $input: DeleteCandidateNoteInput!
    $condition: ModelCandidateNoteConditionInput
  ) {
    deleteCandidateNote(input: $input, condition: $condition) {
      id
    }
  }
`;

export const updateAnalysisRequirements = /* GraphQL */ `
  mutation UpdateAnalysisRequirements(
    $input: UpdateAnalysisRequirementsInput!
  ) {
    updateAnalysisRequirements(input: $input) {
      message
      __typename
    }
  }
`;

export const updateCandidateEmailCorrespondence = /* GraphQL */ `
  mutation UpdateCandidateEmailCorrespondence(
    $input: UpdateCandidateEmailCorrespondenceInput!
    $condition: ModelCandidateEmailCorrespondenceConditionInput
  ) {
    updateCandidateEmailCorrespondence(input: $input, condition: $condition) {
      id
      organizationId
      candidateId
      atsCandidateId
      subject
      body
      recipientEmailAddress
      senderEmailAddress
      status
      scheduleId
      scheduledAt
      sentAt
      sesMessageId
      createdAt
      updatedAt
    }
  }
`;

export const initializeCandidateBatchGroup = /* GraphQL */ `
  mutation InitializeCandidateBatchGroup(
    $input: InitializeCandidateBatchGroupInput!
  ) {
    initializeCandidateBatchGroup(input: $input) {
      id
      organizationId
      userId
      name
      createdAt
      updatedAt
    }
  }
`;

export const updateCandidateBatchGroupComponents = /* GraphQL */ `
  mutation UpdateCandidateBatchGroupComponents(
    $input: UpdateCandidateBatchGroupComponentsInput!
  ) {
    updateCandidateBatchGroupComponents(input: $input) {
      id
      organizationId
      userId
      name
    }
  }
`;

export const updateCandidateBatchGroup = /* GraphQL */ `
  mutation UpdateCandidateBatchGroup(
    $input: UpdateCandidateBatchGroupInput!
    $condition: ModelCandidateBatchGroupConditionInput
  ) {
    updateCandidateBatchGroup(input: $input, condition: $condition) {
      id
      organizationId
      userId
      createdAt
      updatedAt
    }
  }
`;

export const processCandidateBatches = /* GraphQL */ `
  mutation ProcessCandidateBatches($input: ProcessCandidateBatchesInput!) {
    processCandidateBatches(input: $input) {
      id
      organizationId
      userId
      name
      createdAt
      updatedAt
      candidateBatches {
        items {
          id
          atsJobId
        }
      }
    }
  }
`;

export const addCVsToCandidateBatch = /* GraphQL */ `
  mutation AddCVsToCandidateBatch($input: AddCVsToCandidateBatchInput!) {
    addCVsToCandidateBatch(input: $input) {
      id
      cvS3Keys
      jobDescription
      status
      createdAt
      updatedAt
    }
  }
`;
